import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../../../SpaAndWellCommonStyles.module.scss'
import metadata from './BusinessInformation.metadata.json5';
import EmployeeInformation from '../EmployeeInformation/EmployeeInformation';

function BusinessInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('BusinessInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const getTotalEmpCount = () => {
        let empCount = 0;

        if (!_.isUndefined(modelVM.numofConEmpFie.value) ) {
            empCount += _.get(modelVM, 'numofConEmpFie.value');
        }

        if (!_.isUndefined(modelVM.numofPartimEmpFie.value) ) {
            empCount += _.get(modelVM, 'numofPartimEmpFie.value');
        }

        if (!_.isUndefined(modelVM.numofFultimEmpFie.value) ) {
            empCount += _.get(modelVM, 'numofFultimEmpFie.value');
        }

        _.set(modelVM, 'totEmpFie.value', empCount);

        return empCount;
    }


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        totEmpFie: {
            disabled: true,
            value: getTotalEmpCount()
        },
        empInfoComponent: {
            data: modelVM.pswfulTimConEmpExpos,
            updateWizardData,
            submissionVM,
            eventLocPath: `${pathUpdated}.pswfulTimConEmpExpos`
        },
        ifOthExpFie: {
            visible: _.get(modelVM, 'comStrFie.value.code') === 'other'
        },        
        fullTimeConEmp: {
            visible: !_.isUndefined(modelVM.totEmpFie.value) &&  modelVM.totEmpFie.value > 0
        },
        isthiahombusFie: {
            visible: false
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            empInfoComponent: EmployeeInformation
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

BusinessInformationComponent.propTypes = wizardProps;
export default withRouter(BusinessInformationComponent);
